import { bindClient, isNotFoundFailure } from "@spiriidk/utils";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { getLogo } from "connect-api/logo/api/get-logo";
import type { Logo } from "connect-api/logo/schemas/logo";

import { typedFetch } from "~/api/typed-fetch";

const logoApi = bindClient({ getLogo }, typedFetch);

function toLogoUrl({ logo, s3Url }: Logo): string | null {
  return logo ? `${s3Url}${logo}` : null;
}

const logoQueryOptions = {
  all: () => ["logo"] as const,
  current: () =>
    queryOptions({
      queryKey: [...logoQueryOptions.all(), "current"] as const,
      queryFn: async ({ signal }) => toLogoUrl(await logoApi.getLogo(signal)),
      staleTime: Infinity,
      retry: (failureCount, error) =>
        !isNotFoundFailure(error) && failureCount < 3,
    }),
};

function useLogo() {
  const query = useSuspenseQuery(logoQueryOptions.current());
  return {
    logoUrl: query.data ?? undefined,
  };
}

export { logoQueryOptions, useLogo };
